import {ActionIcon, useMantineColorScheme} from '@components/mantine';
import {IconMoon, IconSun} from '@coveord/plasma-react-icons';
import {FunctionComponent} from 'react';

export const DarkModeSwitch: FunctionComponent = () => {
    const {colorScheme, toggleColorScheme} = useMantineColorScheme();
    const checked = colorScheme === 'dark';
    return (
        <ActionIcon.Quaternary onClick={toggleColorScheme} aria-label="Toggle color scheme">
            {checked ? <IconSun /> : <IconMoon />}
        </ActionIcon.Quaternary>
    );
};
